import React from 'react';
import Waste from '../../components/Waste/Waste.js';

function UrbanCircularity() {
  return(
      <Waste/>
  ) 
}

export default UrbanCircularity;